import { Link, useLocation } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { t } from '@/utils/i18n'
import './Sidebar.css'

const iconClass = 'bottom-nav__icon-svg'

// 하단 코칭 메뉴는 숨김 (가이드에 따름)
const menuItems = [
  {
    path: '/dreams',
    labelKey: 'pages.dreams',
    icon: (
      <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
  },
  {
    path: '/calendar',
    labelKey: 'pages.calendar',
    icon: (
      <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    path: '/dashboard',
    labelKey: 'pages.dashboard',
    icon: (
      <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
]

function Sidebar() {
  const location = useLocation()
  const { language } = useLanguage()
  // 현재 경로가 메뉴 아이템과 일치하는지 확인 (하위 경로 포함)
  const isActiveRoute = (path: string) => {
    return location.pathname.startsWith(path)
  }

  return (
    <nav className="bottom-nav">
      {menuItems.map((item) => {
        const isActive = isActiveRoute(item.path)
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`bottom-nav__item bottom-nav__item--${item.path.slice(1) || 'dreams'} ${isActive ? 'bottom-nav__item--active' : ''}`}
          >
            <span className="bottom-nav__icon">{item.icon}</span>
            <span className="bottom-nav__label">{t(item.labelKey, language)}</span>
          </Link>
        )
      })}
    </nav>
  )
}

export default Sidebar


